import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_NAME, TWITTER_HANDLE } from './siteConfig';
import { serializeJsonLd } from './structuredData';

const GSC_VERIFICATION = process.env.REACT_APP_GSC_VERIFICATION;

/**
 * Invisible SEO head tags — title, meta, canonical, OG/Twitter, JSON-LD.
 * Does not render any visible UI.
 */
const SeoHead = ({
  title,
  description,
  canonical,
  ogImage,
  ogType = 'website',
  robots,
  jsonLd,
}) => {
  const jsonLdString = serializeJsonLd(jsonLd);

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {robots && <meta name="robots" content={robots} />}

      {GSC_VERIFICATION && (
        <meta name="google-site-verification" content={GSC_VERIFICATION} />
      )}

      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:site_name" content={SITE_NAME} />
      {ogType && <meta property="og:type" content={ogType} />}
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content="summary_large_image" />
      {TWITTER_HANDLE && <meta name="twitter:site" content={TWITTER_HANDLE} />}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {jsonLdString && (
        <script type="application/ld+json">{jsonLdString}</script>
      )}
    </Helmet>
  );
};

export default SeoHead;
